import * as React from 'react';
import {DataGrid} from '@mui/x-data-grid';
import {Card, CardContent, Typography} from '@mui/material';
import {ITableResultData} from '../resources/config-schema';

interface ITableResultContainerProps {
    title: string;
    data: ITableResultData
}

export function TableResultContainer({title, data}: ITableResultContainerProps) {
    return <Card sx={{height: 1}}>
        <CardContent>
            <Typography variant='subtitle1' sx={{
                fontWeight: 'bold',
                marginBottom: 2
            }}>
                {title}
            </Typography>
            <DataGrid
                rows={data.rows}
                columns={data.columns}
                hideFooterPagination={true}
                hideFooter={true}
                className='basis-full lg:basis-1/2'
            />
        </CardContent>
    </Card>
}